
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'container': {'right': `0`,'bottom': `0`,'position': `fixed`,'display': `flex`,'flexDirection': `column`,'justifyContent': `center`,'borderRadius': `100%`,'backgroundColor': `#000000`,'alignItems': `center`,'padding': `8px`,'margin': `8px`,'borderColor': `#000000`,'borderStyle': `solid`,'borderWidth': `2px`,'zIndex': `130`,'cursor': `pointer`,'width': `50px`,},'checkoutTextStyles': {'color': `#ffffff`,},'cartBadge': {'right': `0px`,'color': `#ffffff`,'backgroundColor': `#9d2a21`,},
        
      };
    };
  